module.exports = __webpack_public_path__ + "03_long_gold.62dfc4d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_long_gold.png
// module id = P2oK
// module chunks = 0